import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { SessionService } from '../services/session/session.service';

/**
 * Guard that redirects to live-tests if user is in monitor mode
 * and attempts to navigate to any other route.
 */
@Injectable({
  providedIn: 'root'
})
export class MonitorModeRedirectGuard implements CanActivate {
  constructor(
    private sessionService: SessionService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const isInMonitorMode = this.sessionService.isInMonitorMode$.getValue();

    if (isInMonitorMode) {
      console.log('[MonitorModeRedirectGuard] User in monitor mode - redirecting to live-tests');
      this.router.navigate(['/live-tests']);
      return false;
    }

    return true;
  }
}
